import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CgDrawer from 'modules/Common/layout/CgDrawer';
import { useTranslation } from 'react-i18next';
import { LITE_SIDEBAR_WIDTH, LiteSidebarContent } from './LiteSidebar';

// Q5 (S7 fix batch 3, D32): below `md`, `LiteSidebar`'s fixed rail is
// hidden entirely (crushing main content otherwise — at 390px it stayed at
// its full ~230px width) and this overlay drawer is the only way to reach
// the nav — reusing the SAME `LiteSidebarContent` the desktop rail renders,
// per CgDrawer (Radix Dialog: backdrop, focus trap, Escape-to-close,
// backdrop-click-to-close, and keyboard-accessible/focus-visible for free).
// Also closes on every route change, so navigating from the drawer doesn't
// leave it open over the new page.
export default function MobileNavDrawer({ open, onOpenChange }) {
  const { t } = useTranslation('freeSupplier');
  const location = useLocation();

  useEffect(() => {
    if (open) onOpenChange(false);
    // Only the pathname should close it — re-running on `open`/`onOpenChange`
    // identity would close it the instant it opens.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return (
    <CgDrawer
      open={open}
      onOpenChange={onOpenChange}
      placement="left"
      modal
      width={Math.min(LITE_SIDEBAR_WIDTH + 60, 300)}
      closeButton
      title={t('mobileNavDrawer.title', 'Menu')}
      contentClassName="md:hidden"
    >
      <div className="-mx-4 -my-4 flex flex-col min-h-full">
        <LiteSidebarContent />
      </div>
    </CgDrawer>
  );
}
